<h3>Aufwände akkumuliert</h3>

<kendo-chart>
  <kendo-chart-series>
    <kendo-chart-series-item type="area" [data]="data" field="value" categoryField="date">
    </kendo-chart-series-item>
  </kendo-chart-series>
  <kendo-chart-tooltip format="{0}: {1:N0}"> </kendo-chart-tooltip>
</kendo-chart>
